import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  q: 'What happens on the free consultation call?',
  a: 'FleetScale reviews your current operations, identifies bottlenecks, and maps the first practical steps toward a more scalable business.'
}, {
  q: 'Do you only work with trucking companies?',
  a: 'FleetScale specializes in transportation and asset-based transporter operations, with deep experience in trucking, logistics, dispatch, compliance, back office, and technology.'
}, {
  q: 'How fast can we expect results?',
  a: 'Timelines depend on the bottleneck and implementation pace. The goal is to identify early wins quickly while building sustainable systems for long-term growth.'
}, {
  q: 'Is this just consulting, or do you help implement?',
  a: 'FleetScale is built around implementation, operating rhythm, and accountability — not just recommendations.'
}, {
  q: 'Do you work with owner-operators and small fleets?',
  a: 'Yes. FleetScale and its related FSG ecosystem support owner-operators, small fleets, and larger transportation teams, but the engagement should be matched to business size and need.'
}, {
  q: 'What makes FleetScale different?',
  a: 'FleetScale combines transportation experience, operational strategy, technology, compliance, dispatch, back-office process, and accountability into one practical growth framework.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="section-padding bg-white" data-id="element-29">
      <div className="container-custom" data-id="element-30">
        <div className="max-w-3xl mx-auto" data-id="element-31">
          <div className="text-center mb-12" data-id="element-32">
            <h2 className="text-3xl md:text-4xl font-bold text-navy font-heading" data-id="element-33">
              Frequently Asked Questions
            </h2>
          </div>

          <div className="space-y-4" data-id="element-34">
            {faqs.map((faq, index) => <div key={index} className={`border ${openIndex === index ? 'border-navy bg-off-white' : 'border-steel bg-white'} rounded-sm overflow-hidden transition-colors`} data-id="element-35">
                <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-36">
                  <span className="font-bold font-heading text-lg text-navy pr-8" data-id="element-37">
                    {faq.q}
                  </span>
                  <span className="flex-shrink-0 text-red" data-id="element-38">
                    {openIndex === index ? <Minus className="w-5 h-5" data-id="element-39" /> : <Plus className="w-5 h-5" data-id="element-40" />}
                  </span>
                </button>

                <AnimatePresence data-id="element-41">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-42">
                      <div className="px-6 pb-5 text-body/80 leading-relaxed border-t border-steel/50 pt-4" data-id="element-43">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}